import { loggedIn } from '../lib';
import { showLightbox } from './lightbox';
import { setSavedProductsCount } from './savedProducts';

const activateProducts = () => {
  $('input[name="favourite"]:not(.enabled)').on('change', ({ target: input }) => {
    const $input = $(input);
    const productID = $input.attr('value');
    const state = input.checked;
    const $form = $input.closest('form');
    const endpoint = $form.attr('action');
    const method = $form.attr('method');

    if (loggedIn()) {
      $.ajax({
        url: endpoint,
        type: method,
        data: JSON.stringify({ productID, state }),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: ({ status, saved_products }) => {
          if (status === 'success') {
            setSavedProductsCount(saved_products);
          }
        }
      });
    }
    else {
      $input[0].checked = $input[0].checked;
      showLightbox('Login to <a href="/your-tools/save-and-compare">save and compare</a>', 'login');
    }
  }).addClass('enabled');
};

export { activateProducts };
